"use client";

import { Modal } from "@/components/organisms/modal/export";
import { isObjectIdValid } from "@/utils/text/validations";

import OngoingSessionActions from "./actions";
import { useOngoingSessionContext } from "./context";
import OngoingSessionImage from "./image";

export default function OngoingSessionModal() {
  const { open, values, setOpen } = useOngoingSessionContext();

  const isValidCargoId = isObjectIdValid(values.cargoId);

  return (
    <Modal.Root
      open={open}
      handleOpen={() => setOpen(!open)}
      className="p-4 sm:p-6 md:min-w-[620px]"
    >
      <div className="flex flex-col items-center gap-4 text-center sm:gap-6">
        <OngoingSessionImage />
        <h2 className="font-poppins text-xl font-normal text-raven-600 sm:text-2xl">
          Ainda está buscando um{" "}
          <span className="font-medium">
            {isValidCargoId ? values?.name : values?.cargoId}
          </span>
          ?
        </h2>
        <OngoingSessionActions />
      </div>
    </Modal.Root>
  );
}
